/*
 * Copyright (C) 2019 Toshiba Corporation
 * SPDX-License-Identifier: Apache-2.0
 */

export interface DChartSeriesFillComputedOptions {
	enable?: boolean;
	color?: number;
	alpha?: number;
}

export interface DChartSeriesFillComputed {
	enable: boolean;
	color: number;
	alpha: number;
}
